import React from 'react';
import type { PageProps } from './page';
import { Page } from './page';

export const NotFound = (props: Pick<PageProps, 'className' | 'reset'>): React.ReactElement => (
  <Page code={404} message='Sorry, we were unable to find that page' {...props} />
);
